import React, { JSX } from 'react';

import { Panel, Panels, spacing, usePublicaTranslation } from '~/src/dash/publicaUI';
import { CustomDataTable } from '~/src/dash/views/inventory-rules-v2/CustomData/CustomDataTable';
import { TopBar } from '~/src/dash/views/topbar/TopBar';

export const CustomDataList = (): JSX.Element => {
  const { t } = usePublicaTranslation();
  return (
    <Panels max vertical relative minWidthMain>
      <Panel largeHorizontalPadding paddingTop={spacing.small} paddingBottom={spacing.extraLarge}>
        <TopBar title={t('InventoryRulesCustomData')} enableUINotices />
      </Panel>
      <Panels max vertical relative minWidthMain scroll>
        {/* ADD WHEN FORMS ARE IMPLEMENTED */}
        {/* <Panel largeHorizontalPadding style={{ alignSelf: 'flex-end' }}>
          <ButtonV2
            small
            onClick={() => undefined}
            tKey='PlusAddItem'
            tProps={{ item: t('CustomData') }}
          />
        </Panel> */}
        <Panel>
          <CustomDataTable />
        </Panel>
      </Panels>
    </Panels>
  );
};
